<script setup>
import { shallowRef, onMounted } from 'vue'
import Smile1 from './icons/Smile1.vue'
import Smile2 from './icons/Smile2.vue'
import Smile3 from './icons/Smile3.vue'
import Smile4 from './icons/Smile4.vue'
import Smile5 from './icons/Smile5.vue'
import Smile6 from './icons/Smile6.vue'

const smiles = [
  markRaw(Smile1),
  markRaw(Smile2),
  markRaw(Smile3),
  markRaw(Smile4),
  markRaw(Smile5),
  markRaw(Smile6),
]
const smile = shallowRef(null)

onMounted(() => {
  smile.value = smiles[Math.floor(Math.random() * smiles.length)]
})
</script>

<template>
  <component :is="smile" class="spinner" />
</template>

<style lang="scss" scoped>
.spinner {
  max-inline-size: 30vw;
  max-block-size: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(0deg);

  color: $color-red;

  animation: flickering 0.5s infinite;

  @keyframes flickering {
    0%,
    33% {
      color: $color-red;
    }
    34%,
    66% {
      color: $color-green;
    }
    67%,
    100% {
      color: $color-blue;
    }
  }
}
</style>
